/**
 * AI:
 * Status: "in progress"
 * Type: Page
 * SubType: Overview (shell-consultant)
 * Reason: „Kunden in meiner Nähe" in the Co-App (shell-consultant, route `cr/nearby-customers`, also
 *         mounted under `/mobile`). The same shared <cr-nearby-customers> component as shell-alpha;
 *         only the answer to a pick differs: the consultant shell has no right-hand object panel, so
 *         the customer opens in the SAME tab on its consultant customer page - relative to the
 *         shell prefix route, so `/mobile` survives (the pattern of the Kundenanlage page).
 */
import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {PageComponent} from '../../../../../core/shared/mvs-page/page.component';
import {MvsCoreService} from '../../../../../core/shared/service/mvs-core.service';
import {ObjectIdentifier} from '../../../../../core/shared/basic/object-identifier';

@Component({
    selector: 'cr-nearby-customers-consultant-page',
    templateUrl: './cr-nearby-customers-consultant.page.html',
    standalone: false
})
export class CrNearbyCustomersConsultantPage extends PageComponent implements OnInit {

    constructor(
        protected override route: ActivatedRoute,
        protected override coreService: MvsCoreService,
        protected router: Router) {
        super(route, coreService);
    }

    override ngOnInit(): void {
        this.defaultLabel = 'Kunden in meiner Nähe';
        super.ngOnInit();
        this.initComponent();
    }

    /**
     * Initialize Component.
     */
    initComponent(): void {
        this.refreshComponent();
    }

    /**
     * Refresh Component.
     */
    refreshComponent(): void {
        this.initialized = true;
    }

    /**
     * A customer was picked on the map or in the distance list - open its consultant customer page
     * in the SAME tab.
     *
     * Relative to the PARENT route: shell-consultant mounts every sub route twice (under '' and under
     * 'mobile'), and this page is routed as one full path directly below that prefix route. Commands
     * relative to it keep `/mobile`; an absolute '/cr/customers/..' would drop it. Without a parent
     * the router resolves against the root, i.e. the absolute URL.
     * @param identifier objectType 'cr.Customer', objectId = the customer id
     */
    handleCustomerSelect(identifier: ObjectIdentifier): void {

        if (!identifier?.objectId) {
            return;
        }

        this.router.navigate(['cr', 'customers', identifier.objectId], {relativeTo: this.route?.parent ?? null});
    }
}
